<template>
    <vue-modal :open="open" class="drug-add">
        <div class="bax-icon bax-success d-flex align-items-center justify-content-center">
            <i class="icon-tick"></i>
        </div>
        <h2 v-if="!isTPN()">Drug Added to Order</h2>
        <span class="inline-block mb-3 text-sm text-red-600" v-if="draftSaved">Draft saved {{  convertDraftUpdateDate() }}</span>
        <h2 v-if="isTPN()">Product Added to Order</h2>
        <p v-if="patient.firstName">Add another drug for {{ patient.firstName }} {{ patient.lastName }}?</p>
        <div class="bax-modal-action-items">
            <ul class="d-md-flex justify-content-center">
                <li>
                    <a href="#" @click.prevent="$emit('close')"
                        class="bax-btn bax-btn-blue">Add another {{isTPN()?'product':'drug'}}</a>
                </li>
            </ul>
        </div>
        <hr />
        <template v-if="!isTPN()">
        <div class="bax-icon bax-success d-flex align-items-center justify-content-center">
            <i class="icon-tick"></i>
        </div>
            <p>Add another patient</p>
            <div class="bax-modal-action-items">
                <ul class="d-md-flex justify-content-center">
                    <li>
                        <a href="#" @click.prevent="goToSelectPatient" class="bax-btn bax-btn-bordered bax-btn-bordered-green d-flex align-items-center">
                            <i class="icon-new-patient"></i> Add another patient
                        </a>
                    </li>
                </ul>
            </div>
            <hr />
        </template>
        <div class="bax-icon bax-success d-flex align-items-center justify-content-center">
            <i class="icon-tick"></i>
        </div>
        <p  v-if="!isTPN()">Review and complete this order</p>
        <div class="bax-modal-action-items">
            <ul class="d-md-flex justify-content-center">
                <li>
                    <button
                        class="bax-btn bax-btn-bordered bax-btn-bordered-green d-flex align-items-center"
                        type="button"
                        @click="goToReview"
                    >
                        <i class="icon-new-patient"></i> Review & complete order
                    </button>
                </li>
            </ul>
        </div>
    </vue-modal>
</template>

<script>
    import moment from 'moment';
    import tpnMixin from '@/mixins/tpnMixin';

    export default {
    name: 'AddDrugCompleteModal',
        mixins: [tpnMixin],
    props: ['open', 'patient', 'draftSaved'],
    methods: {
        convertDraftUpdateDate() {
            return moment.unix(this.draftSaved).format('DD MMM YYYY HH:mm')
        },
        goToSelectPatient() {
            this.$router.push({
                path: `/order/${this.$route.params.orderId}/select-patient`,
            });
        },
         goToReview() {
            const { patient } = this.$route.params;

            if (this.isTPN()) {
                this.$router.push({
                    name: 'reviewCompleteTPN',
                    params: {
                        orderId: this.$route.params.orderId,
                    },
                    query: {
                        patient,
                    },
                });
            } else if (patient !== '' && typeof patient !== 'undefined') {
                this.$router.push({
                    name: 'reviewComplete',
                    params: {
                        orderId: this.$route.params.orderId,
                    },
                    query: {
                        patient,
                    },
                });
            } else {
                 this.$router.push({
                    name: 'reviewComplete',
                    params: {
                        orderId: this.$route.params.orderId,
                    },
                });
            }
        },
    },
};
</script>
